.input {
    font-size: var(--mantine-font-size-sm);
    font-weight: bold;
    margin-top: 0;
}

.newCallIcon {
    margin-right: 2px;
}

.description {
    margin-bottom: -14px;
    font-size: var(--mantine-font-size-xs);
}

.cancelButton {
    color: var(--mantine-color-gray-3);
    text-decoration: underline;
}

.noControlsWrapper {
    /* TODO: evaluate what css properties are actually needed here */
    background: var(--mantine-color-gray-9);
    color: var(--mantine-color-gray-1);
    padding: 13px 20px;
    margin: 0.9375rem 1.0625rem;
    border-radius: 24px;
    z-index: var(--mantine-priority-higher);
    /*  TODO: post launch, explore other options for responsiveness */
    height: fit-content;
    min-width: 28rem;
    top: 4rem;
    position: fixed;
}

.callbackNoControlsWrapper {
    gap: 12px;
    display: flex;
    flex-direction: column;
    background: var(---exwo-color-control-bar-bg);
    color: var(--mantine-color-gray-1);
    padding: 13px 15px;
    margin: 0.9375rem 1.0625rem 0rem 1.0625rem;
    border-radius: 24px;
    height: fit-content;
    min-width: 24rem;
    max-width: 46.25rem;
    /*  TODO: post launch, explore other options for responsiveness */
    width: 50vw;
}
